var path = 'app/admin/users/userTooltipPopup.html';
var html = "<div class=\"user-tooltip\">\n  <div>{{\"admin.userManagement.hints.\" + content.title | i18n}}</div>\n</div>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;